import { render, staticRenderFns } from "./Buffer.vue?vue&type=template&id=df3a4e46&lang=pug"
import script from "./Buffer.vue?vue&type=script&lang=js"
export * from "./Buffer.vue?vue&type=script&lang=js"
import style0 from "./Buffer.vue?vue&type=style&index=0&id=df3a4e46&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports